module.exports = "/assets/data/1bc8f220074edcf2a8229e8fea180c98-DE55.data.json";